// opervex-frontend/src/Opervex/ServiceManagement/Service.js

class Services {
  #_api; // Definição de campo privado

  constructor(api) {
    this.#_api = api;
  }

  async findId(id) {
    return this.#_api.get("/ServiceManagement/Service/" + id);
  }

  async update(id, data) {
    return this.#_api.put("/ServiceManagement/Service/" + id, data);
  }

  async create(data) {
    return this.#_api.post("/ServiceManagement/Service/", data);
  }

  async findAll() {
    return this.#_api.get("/ServiceManagement/Service");
  }

  async getSales() {
    return this.#_api.get("/ServiceManagement/Service?service_type=7");
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "externalCode",
        label: "Código Externo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "type",
        label: "Tipo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

// Export the class itself (not an instance)
export default Services;
